export const environment = {
    production: true,
    restApiBaseUrl: '/api',
    recaptchaUrl: 'https://recaptcha.net/recaptcha/api.js'
};
